module.exports = __webpack_public_path__ + "static/media/optima-seguros-logo.1ab13f5b.svg";